import { ForgotPasswordRequest } from '../../../models/requests/forgetpassword.request';
import axios from '../../axios';

export default async function forgotPasswordRequest(
  request: ForgotPasswordRequest
): Promise<void> {
  const response = await axios.post<void>(
    `${process.env.REACT_APP_BASE_URL}/auth/forgot-password `,
    request
  );
  return response.data;
}
